export default "__VITE_ASSET__D$72$WPe__"